import { Component } from 'react';

class TreeTableComponent extends Component {
    render() {
        let { _pageScope, moduleId, ...others } = this.props;
        return _pageScope.props.treeTableManyCol.treeTableCol(moduleId ?? others.items?.code, others);
    }
}

export default TreeTableComponent;